// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"02b44fd4","453":"864bd43b"}[chunkId] + ".chunk.js";
};